import { Component, inject, signal, Type } from '@angular/core';
import { Tab, TabList, Tabs } from 'primeng/tabs';
import { Paginator, PaginatorState } from 'primeng/paginator';
import { Bell02 } from '../../../infrastructure/shared/icons/bell-02/bell-02';
import { Check } from '../../../infrastructure/shared/icons/check/check';
import { ChevronRight } from '../../../infrastructure/shared/icons/chevron-right/chevron-right';
import { EyeOff } from '../../../infrastructure/shared/icons/eye-off/eye-off';
import { DynamicIconComponent } from '../../../infrastructure/shared/ui/dynamic-icon/dynamic-icon';
import {
  NOTIFICATION_ICON_MAP,
  NotificationIcon,
} from '../../../infrastructure/shared/components/notifications/notifications';
import { NotificationService } from '../../../infrastructure/shared/services/notification.service';

@Component({
  standalone: true,
  selector: 'app-admin-notifications',
  imports: [
    Tabs,
    TabList,
    Tab,
    Bell02,
    EyeOff,
    Check,
    ChevronRight,
    DynamicIconComponent,
    Paginator,
  ],
  templateUrl: './admin-notifications.html',
  styleUrl: './admin-notifications.scss',
})
export class AdminNotifications {
  protected notificationService = inject(NotificationService);

  protected items = this.notificationService.items;
  protected paginatedData = this.notificationService.paginatedData;
  protected first = this.notificationService.first;

  protected activeTab = signal<number>(0);

  constructor() {
    this.notificationService.loadNotifications();
    this.notificationService.loadUnreadCount();
  }

  protected iconFor(type: NotificationIcon): Type<any> {
    return NOTIFICATION_ICON_MAP[type];
  }

  protected onTabChange(value: unknown) {
    const tab = Number(value ?? 0);
    this.activeTab.set(tab);
    this.notificationService.loadNotifications(tab === 1);
  }

  protected onPageChange(event: PaginatorState) {
    this.notificationService.onPageChange({
      first: event.first ?? 0,
      rows: event.rows ?? this.paginatedData().pageSize,
    });
  }

  protected markAllAsRead() {
    this.notificationService.markAllAsRead();
  }

  protected markAsRead(id: string) {
    this.notificationService.markAsRead(id);
  }
}
